import React, { useEffect, useMemo, useState } from "react";
import { Link, useSearchParams } from "react-router-dom";
import { fetchProducts } from "@/lib/api";
import ProductCard from "@/components/ProductCard";
import { PaisleyDivider, Lotus } from "@/lib/motifs";

const Shop = () => {
    const [searchParams] = useSearchParams();
    const [products, setProducts] = useState([]);
    const [loading, setLoading] = useState(true);

    // Filter buttons hata diye gaye hain. Header ka search (?search=) aur Collections (?featured=) abhi bhi kaam karte hain.
    const filters = useMemo(() => ({
        material: searchParams.get("material") || "",
        occasion: searchParams.get("occasion") || "",
        region: searchParams.get("region") || "",
        search: searchParams.get("search") || "",
        min_price: searchParams.get("min_price") || "",
        max_price: searchParams.get("max_price") || "",
        featured: searchParams.get("featured") || "",
    }), [searchParams]);

    useEffect(() => {
        setLoading(true);
        const params = {};
        Object.entries(filters).forEach(([k, v]) => { if (v) params[k] = v; });
        fetchProducts(params).then((data) => { setProducts(data); setLoading(false); }).catch(() => setLoading(false));
    }, [filters]);

    return (
        <div className="container-x py-14" data-testid="shop-page">
            <div className="text-center mb-10">
                <Lotus className="mx-auto mb-3" />
                <p className="font-devanagari text-[color:var(--gold)] text-sm">संग्रह</p>
                <h1 className="font-heading text-5xl md:text-6xl text-[color:var(--maroon)] mt-1">The Collection</h1>
                <PaisleyDivider className="mt-4" />
                <p className="font-body text-[color:var(--ink-muted)] mt-4 max-w-xl mx-auto">
                    {products.length} handcrafted piece{products.length === 1 ? "" : "s"} across materials, occasions and regions of India.
                </p>
                {filters.search && (
                    <p className="font-ui text-xs tracking-widest-x uppercase text-[color:var(--copper)] mt-4">
                        Results for “{filters.search}” ·{" "}
                        <Link to="/shop" className="underline underline-offset-4" data-testid="clear-search">View all</Link>
                    </p>
                )}
            </div>

            {/* Grid */}
            <div className="border-t border-[color:var(--border-gold)] pt-10">
                {loading ? (
                    <div className="text-center py-24 font-body text-[color:var(--ink-muted)]">Loading heritage pieces…</div>
                ) : products.length === 0 ? (
                    <div className="text-center py-24 border border-[color:var(--border-gold)]">
                        <p className="font-heading text-2xl text-[color:var(--maroon)]">No pieces found</p>
                        <p className="font-body text-[color:var(--ink-muted)] mt-2">Try a different search, or browse the full collection.</p>
                        <Link to="/shop" className="btn-primary mt-6 inline-flex">View All</Link>
                    </div>
                ) : (
                    <div className="grid grid-cols-2 lg:grid-cols-4 gap-8" data-testid="product-grid">
                        {products.map((p, i) => <ProductCard key={p.id} product={p} index={i} />)}
                    </div>
                )}
            </div>
        </div>
    );
};

export default Shop;